import React from 'react';

export const InputRadioErrorContext = React.createContext<string | undefined>(undefined);

type Props = {
	errorMessage?: string;
	children: React.ReactNode;
};

export function InputRadioErrorContextProvider({ children, errorMessage }: Props) {
	return <InputRadioErrorContext.Provider value={errorMessage}>{children}</InputRadioErrorContext.Provider>;
}
